import React from 'react';
import PropTypes from 'prop-types';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import get from 'lodash/get';

import ExpirationDate from '@src/custom/expiration-date';

const ContentImageItem = ({ image }) => {
    return (
        <Card variant="outlined">
            <Grid container sx={{ width: '100%' }} spacing={0}>
                <Grid size={{ xs: 12, sm: 3, md: 2 }}>
                    <CardMedia
                        sx={{
                            height: '100%',
                            width: '100%',
                            minHeight: '6rem',
                        }}
                        image={get(image, 'source')}
                        title={get(image, 'alt')}
                    />
                </Grid>
                <Grid
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                    size={{ xs: 12, sm: 9, md: 10 }}
                >
                    <CardContent sx={{ flex: '1 0 auto' }}>
                        <Typography component="h5" variant="h5">
                            { get(image, 'alt') }
                        </Typography>
                        <ExpirationDate expiredAt={get(image, 'expired_at')} />
                    </CardContent>
                </Grid>
            </Grid>
        </Card>
    );
};

ContentImageItem.propTypes = {
    image: PropTypes.object.isRequired,
};

export default ContentImageItem;
